// src/pages/Homepage.jsx

import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import HeroSection from '../components/sections/HeroSection'; // Atualizado
import { Helmet } from 'react-helmet-async';
import CTASection from '../components/sections/CTASection';
import PricingSection from '../components/sections/PricingSection';
import Card from '../components/ui/Card';
import { comandos, destaques, categorias } from '../data/comandos';

const categoriaPorId = Object.fromEntries(categorias.map((c) => [c.id, c]));

const HomePage = () => {
  const { hash } = useLocation();

  // Suporta links tipo /#planos (ex.: "Ver planos" no dashboard) rolando ate a
  // secao depois que a pagina renderiza — o navegador nao faz isso sozinho em
  // uma SPA, so em navegacao de pagina cheia.
  useEffect(() => {
    if (!hash) return;
    const elemento = document.getElementById(hash.slice(1));
    elemento?.scrollIntoView({ behavior: 'smooth' });
  }, [hash]);

  return (
    <div>
      <Helmet>
        <title>RNPlugin - Automação para Rodovia, Ferrovia e Loteamento no Civil 3D</title>
        <meta
          name="description"
          content={`RNPlugin: ${comandos.length}+ comandos para quem projeta rodovia, ferrovia, loteamento e topografia no Civil 3D — geometria, perfil, corredor, terraplenagem e exportação. Teste grátis por 30 dias.`}
        />
      </Helmet>
      <HeroSection />

      {/* Preview dos comandos mais fortes — da contexto pra quem chega sem
          saber o que o plugin faz, e reforça o link interno pra /comandos
          com texto descritivo (bom pro SEO das duas páginas). */}
      <section className="py-16 lg:py-20 bg-rn-surface">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <p className="eyebrow text-rn-orange-text mb-3">Comandos</p>
            <h2 className="text-[27px] md:text-[32px] font-semibold mb-4 text-rn-navy">
              Feito para a rotina de rodovia, ferrovia, loteamento e topografia
            </h2>
            <p className="text-rn-text-soft max-w-xl mx-auto">
              {comandos.length} comandos pensados para quem projeta rodovia,
              ferrovia, loteamento e topografia no Civil 3D — geometria, perfil,
              corredor e terraplenagem, não desenho genérico. Alguns dos mais
              usados abaixo.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
            {destaques.slice(0, 8).map((cmd) => (
              <Card key={cmd.nome} className="p-6">
                <div className="text-2xl mb-3" aria-hidden="true">
                  {categoriaPorId[cmd.categoria]?.emoji}
                </div>
                <h3 className="font-semibold text-rn-navy mb-2">{cmd.nome}</h3>
                <p className="text-rn-text-soft text-sm">{cmd.descricao}</p>
              </Card>
            ))}
          </div>

          <div className="text-center">
            <Link
              to="/comandos"
              className="inline-block font-semibold text-rn-orange-text hover:text-rn-orange transition-colors"
            >
              Ver todos os {comandos.length} comandos →
            </Link>
          </div>
        </div>
      </section>

      <PricingSection />
      <CTASection />
    </div>
  );
};

export default HomePage;
